import {
  MelcoModelsUserActivityListItem,
  UserAccountApi,
  useAPIQuery,
} from "melco-shared-logic";
import { useTable } from "../table/useTable";
//import { ALL_ORDER_SESSION_STATUS, OrderProductionStatus, OrderSessionStatus } from "../../helper/licencesHelper";
//import { LicencesListFiltersType } from "./LicencesListFiltersType";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useUserHistory = (userId?: string, productCode?: string) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<MelcoModelsUserActivityListItem>({
  //  LicencesListFiltersType
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });
  const query = useAPIQuery(
    UserAccountApi,
    ["userHistory", productCode, currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //    const api = new UserAccountApi(baseApiConfig({ token, impersonationForId: userId ?? "" }));
      let response;
      //   if(filters?.Products) {
      response = await api.productGetActivityList({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        productCode: productCode ?? "",
      });
      //}

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
      apiConfigOptions: {
        impersonationForId: userId ?? "",
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};
